import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  Gateway,
  MicroformCodeBlock,
  MicroformSection,
  MicroformSubmitMode,
  MicroformSubmitModeHints,
  MicroformSubmitModeLabels,
  MicroformSubmitModeSnippets,
  MicroformSubmitModeTokens,
} from '../../_models';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { copyToClipboard } from '../../_helpers';

@Component({
  selector: 'app-microform-docs',
  templateUrl: './microform-docs.component.html',
  styleUrls: ['./microform-docs.component.scss'],
  animations: [
    trigger('expandCollapse', [
      state(
        'collapsed',
        style({
          height: '0px',
          opacity: 0,
          display: 'none',
        })
      ),
      state(
        'expanded',
        style({
          height: '*',
          opacity: 1,
        })
      ),
      transition('collapsed <=> expanded', animate('400ms ease-in-out')),
    ]),
  ],
})
export class MicroformDocsComponent implements OnInit, OnDestroy {
  @Input() gateway: Gateway;

  copiedBlock: MicroformCodeBlock = null;
  codeBlock = MicroformCodeBlock;
  microformSection = MicroformSection;
  submitMode = MicroformSubmitMode;
  submitModeLabels = MicroformSubmitModeLabels;
  submitModeHints = MicroformSubmitModeHints;
  expandedSections: { [key in MicroformSection]?: boolean } = {};
  selectedSubmitMode = MicroformSubmitMode.Form;

  private copiedTimer: any = null;

  ngOnInit(): void {
    this.toggleSection(MicroformSection.IncludeCDN);
  }

  selectSubmitMode(mode: MicroformSubmitMode): void {
    this.selectedSubmitMode = mode;
  }

  get isCustomSubmitMode(): boolean {
    return !!MicroformSubmitModeSnippets[this.selectedSubmitMode];
  }

  get submitModeToken(): string {
    return MicroformSubmitModeTokens[this.selectedSubmitMode];
  }

  get submitModeOptions(): string {
    return Object.keys(MicroformSubmitModeTokens)
      .map((mode) => MicroformSubmitModeTokens[mode])
      .join(', ');
  }

  get codeChangesTitle(): string {
    return `Code Changes for ${MicroformSubmitModeLabels[this.selectedSubmitMode]}`;
  }

  get codeChangesSnippet(): string {
    return MicroformSubmitModeSnippets[this.selectedSubmitMode] || '';
  }

  copyBlock(block: HTMLElement, key: MicroformCodeBlock): void {
    copyToClipboard(block.innerText);

    clearTimeout(this.copiedTimer);
    this.copiedBlock = key;

    this.copiedTimer = setTimeout(() => {
      this.copiedBlock = null;
    }, 1000);
  }

  ngOnDestroy(): void {
    clearTimeout(this.copiedTimer);
  }

  toggleSection(section: MicroformSection): void {
    this.expandedSections[section] = !this.expandedSections[section];
  }

  isExpanded(section: MicroformSection): boolean {
    return !!this.expandedSections[section];
  }

  get publicKey(): string {
    return (this.gateway && this.gateway.public_key) || 'YOUR_PUBLIC_KEY_HERE';
  }
}
